module.exports = __webpack_public_path__ + "static/logo-da663ce2479e45c6000fa97a20f156e2.webp";